module.exports = __webpack_public_path__ + "static/media/garden.14.03ad35e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/standard-garden/images/garden.14.jpg
// module id = 670
// module chunks = 0